export const CONFIRM_EMAIL_MESSAGE = `You'll need to confirm your email before subscribing to a plan`;

export const PAID_PLAN_REQUIRED_MESSAGE = `You'll need a paid plan to use search api`;

export const RESEND_CONFIRMATION_EMAIL_SUCCESS = 'Done! Please check your inbox.';
